import React, { useEffect } from 'react';
import { Button } from '@wix/design-system';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { getAppSettingsPageUrl, isBundleAppAndInstalled, isBundleAppAndNotInstalled, isBundleAppFromVoucher, isNewVersionAvailable, isPendingApp, isSetupIncomplete, openSettingsUrl, } from '../../..';
import { appMarketManageAppsActionRequiredClick, appMarketSpotlightArticle, openAppClick, } from '@wix/bi-logger-app-market-data/v2';
import { useTranslation } from '../../../hooks/use-translation';
import NewAppSettingsModal from '../../modals/app-settings-modal/new-app-settings-modal';
import { useModal } from '../../../hooks/use-modal/use-modal';
export function MainActionButton({ mainButtonAction, app, msid, origin, index, getAppInstance, openModal, embeddedScriptAppsStatus, isActionRequiredApp, siteIsBusinessFirstSite, bundleApps, experiments }) {
    const biLogger = useBiLogger();
    const appId = app?.appId;
    const t = useTranslation();
    const modalController = useModal();
    const onCTAClick = () => {
        if (isActionRequiredApp) {
            biLogger
                .report(appMarketManageAppsActionRequiredClick({
                msid,
                app_id: appId,
                market: origin,
                action_cta: getLabel().biLabel,
            }))
                .catch((e) => console.log(e));
        }
        else {
            biLogger
                .report(openAppClick({
                index,
                msid,
                app_id: appId,
                market: origin,
                tag_type: 'manage_apps',
                tag_name: 'manage_apps',
            }))
                .catch((e) => console.log(e));
        }
        if (getAppSettingsPageUrl(app)) {
            const settingsUrl = openSettingsUrl(app, embeddedScriptAppsStatus, getAppInstance, openModal);
            modalController.open(React.createElement(NewAppSettingsModal, { settingsUrl: settingsUrl, closeModal: modalController.close }));
        }
        else {
            mainButtonAction(app, bundleApps);
        }
    };
    const getLabel = () => {
        if (isBundleAppAndNotInstalled(appId, bundleApps) &&
            isBundleAppFromVoucher(appId, bundleApps)) {
            return {
                label: t('manage-apps.business-apps.add-app'),
                biLabel: 'add-voucher-app',
            };
        }
        if (isBundleAppAndNotInstalled(appId, bundleApps)) {
            return {
                label: t('manage-apps.business-apps.claim-app'),
                biLabel: 'claim-app',
            };
        }
        if (!experiments.enabled('specs.app-market.MoveBundlesToBenefits')) {
            if (isBundleAppAndInstalled(appId, bundleApps)) {
                return {
                    label: t('manage-apps.business-apps.claim-upgrade'),
                    biLabel: 'claim-upgrade',
                };
            }
        }
        if (isNewVersionAvailable(app)) {
            return {
                label: t('manage-apps.business-apps.update-version'),
                biLabel: 'update-version',
            };
        }
        if (isPendingApp(app)) {
            if (siteIsBusinessFirstSite) {
                return {
                    label: t('manage-apps.site-pending.cta'),
                    biLabel: 'create-site',
                };
            }
            return {
                label: t('manage-apps.business-apps.complete'),
                biLabel: 'complete-install',
            };
        }
        if (isSetupIncomplete(app)) {
            return {
                label: t('manage-apps.business-apps.complete-setup'),
                biLabel: 'complete-setup',
            };
        }
        return {
            label: t('manage-apps.business-apps.open'),
            biLabel: 'open',
        };
    };
    useEffect(() => {
        if (isActionRequiredApp) {
            biLogger
                .report(appMarketSpotlightArticle({
                action_cta: getLabel().biLabel,
                app_id: appId,
                msid,
                market: origin,
            }))
                .catch((e) => console.log(e));
        }
    }, []);
    return (React.createElement(Button, { size: "tiny", priority: "primary", onClick: onCTAClick, dataHook: "main-cta" }, getLabel().label));
}
//# sourceMappingURL=main-action-button.js.map